import { Controller } from '@hotwired/stimulus';

// 参照を前提に権限を組み合わせるための入力補助。
// 参照を外したら他をすべて外し、参照以外を付けたら参照を付ける。
// 勝手にチェックが変わったように見えるので、そのつど理由を注意書きで示す。
export default class extends Controller {
  static targets = ['read', 'other', 'notice', 'noticeMessage'];
  static values = { readForcedMessage: String, othersClearedMessage: String };

  // action="input->permission-abilities#toggle"
  toggle({ target }) {
    if (!this.hasReadTarget) return;

    if (target === this.readTarget) {
      if (target.checked) return this.hideNotice();

      const checkedOthers = this.otherTargets.filter((other) => other.checked);
      for (const other of checkedOthers) {
        other.checked = false;
      }
      if (checkedOthers.length === 0) return this.hideNotice();

      this.showNotice(this.othersClearedMessageValue);
    } else if (target.checked && !this.readTarget.checked) {
      this.readTarget.checked = true;
      this.showNotice(this.readForcedMessageValue);
    } else {
      this.hideNotice();
    }
  }

  showNotice(message) {
    if (!this.hasNoticeTarget) return;

    this.noticeMessageTarget.textContent = message;
    this.noticeTarget.hidden = false;
  }

  hideNotice() {
    if (!this.hasNoticeTarget) return;

    this.noticeTarget.hidden = true;
  }
}
